import React from "react";
import { Link } from "react-router-dom";
import { POSTS } from "@/data/blog";
import { Sparkles, Calendar, Clock, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import PublicHeader from "@/components/PublicHeader";

const formatDate = (iso) => new Date(iso).toLocaleDateString("pt-BR", { day: "2-digit", month: "long", year: "numeric" });

export default function Blog() {
  return (
    <div className="min-h-screen relative overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-40 pointer-events-none" />

      <PublicHeader active="blog" />

      <section className="relative z-10 max-w-5xl mx-auto px-6 pt-20 pb-16">
        <p className="text-xs uppercase tracking-[0.2em] text-primary mb-3">Blog SmartStockAI</p>
        <h1 className="font-display text-5xl sm:text-6xl font-bold tracking-tight">
          Inteligência prática para o varejo.
        </h1>
        <p className="text-muted-foreground text-lg mt-5 max-w-2xl leading-relaxed">
          Guias, casos e estratégias para reduzir ruptura, liberar capital parado e tomar decisões com IA — escritos para o lojista brasileiro.
        </p>
      </section>

      <section className="relative z-10 max-w-5xl mx-auto px-6 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {POSTS.map((p, i) => (
            <Link key={p.slug} to={`/blog/${p.slug}`} data-testid={`blog-${p.slug}`} className={`group p-7 rounded-xl border border-border bg-card hover:border-primary/40 hover:-translate-y-1 transition-all ${i === 0 ? "md:col-span-2 md:flex md:items-center md:gap-8" : ""}`}>
              <div className={i === 0 ? "md:flex-1" : ""}>
                <div className="flex items-center gap-3 text-xs text-muted-foreground mb-3">
                  <span className="px-2 py-0.5 rounded-md bg-primary/15 text-primary border border-primary/30">{p.category}</span>
                  <span className="flex items-center gap-1"><Calendar className="w-3 h-3" /> {formatDate(p.date)}</span>
                  <span className="flex items-center gap-1"><Clock className="w-3 h-3" /> {p.readMin} min</span>
                </div>
                <h2 className={`font-display font-bold tracking-tight group-hover:text-primary transition ${i === 0 ? "text-3xl" : "text-xl"}`}>{p.title}</h2>
                <p className="text-sm text-muted-foreground mt-3 leading-relaxed">{p.description}</p>
                <div className="flex items-center gap-2 text-sm text-primary mt-4">
                  Ler artigo <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-1 transition" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <footer className="relative z-10 border-t border-border/50 py-8 text-center text-sm text-muted-foreground">
        © 2026 SmartStockAI · Inteligência preditiva para o varejo
      </footer>
    </div>
  );
}
